import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import MaterialTable from 'material-table';
import Select from 'react-select'

// reactstrap components
import { Button, Card, CardBody, FormGroup, Form, Input, Row, Col, Container } from "reactstrap";

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// services
import { showMessage, showQuestion } from "../../../services/message.js";
import { api_GET, api_POST } from "../../../services/api_service.js";
import { EnviaProtocoloGeradorClasseResiduo, EnviaRequerimentoGeradorClasseResiduo } from "../../../services/protocolo_gerador_service.js";

//Context
import { useAuth } from "../../../context/auth";

export default function Residuos({ item, tipoCadastro, permiteManutencao, handleProximoStep, handleStepAnterior }) {
    const { session, setLoading } = useAuth();

    const { register, handleSubmit, errors, setError, setValue, clearErrors, reset } = useForm({ mode: "onBlur" });

    const [registro, set_registro] = React.useState(null);

    const [residuos, set_residuos] = React.useState([]);

    const loadItemProtocolo = () => {
        set_registro(item);
        loadOptionsClassesResiduo(item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria_Id);
        if (item != null && item.protocoloGerador[0].protocoloGeradorClasseResiduos != null) {
            set_residuos(item.protocoloGerador[0].protocoloGeradorClasseResiduos);
        }
    }
    const loadItemRequerimento = () => {
        set_registro(item);
        loadOptionsClassesResiduo(item.setupSolicitacaoAcao.setupSolicitacao.categoria_Id);
        if (item != null && item.requerimentoGerador[0].requerimentoGeradorClasseResiduo != null) {
            set_residuos(item.requerimentoGerador[0].requerimentoGeradorClasseResiduo);
        }

        if (tipoCadastro == "Requerimento") {
            let _action = actions;
            _action.push({
                icon: 'delete',
                tooltip: 'Remover Classe',
                onClick: (event, rowData) => handleRemove(rowData)
            });

            set_actions(_action);
        }
    }

    useEffect(() => {
        if (tipoCadastro == "Protocolo")
            loadItemProtocolo();
        else if (tipoCadastro == "Requerimento")
            loadItemRequerimento();
    }, []);

    // Material-Table > Actions
    const [actions, set_actions] = useState([
        {
            icon: 'edit',
            tooltip: 'Editar Registro',
            onClick: (event, rowData) => handleEdit(rowData)
        }
    ]);

    const [classeResiduo, set_classeResiduo] = React.useState(null);
    const [optionsClassesResiduo, set_OptionsClassesResiduo] = useState([]);
    const loadOptionsClassesResiduo = (categoria_Id) => {
        api_GET(`ClasseResiduo/GetListAtivosByCategoria/${categoria_Id}`)
            .then(result => set_OptionsClassesResiduo(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleClassesResiduo = (value) => {
        set_classeResiduo(value);
        setValue("classeResiduo", value, true);
        clearErrors("classeResiduo");
    }

    const [rowEdit, set_rowEdit] = React.useState(null);
    const handleEdit = (rowData) => {
        set_rowEdit(rowData);
        set_classeResiduo(rowData);
        setValue("classeResiduo", rowData.classeResiduo_Id, true);
        setValue("quantidadeEstimada", rowData.quantidadeEstimada);
    }

    const handleRemove = (rowData) => {
        if (!permiteManutencao && tipoCadastro == "Protocolo") {
            showMessage("Aviso", "Não permitida a manutenção do cadastro.", 'error', null);
            return;
        }

        showQuestion('Atenção', 'Deseja remover esta classe?', 'question', function (result) {
            if (result) {
                setLoading(true);
                api_POST('requerimentoGerador/PostRemoverGeradorClasseResiduoRequerimento/' + rowData.requerimentoGeradorClasseResiduo_Id)
                    .then(result => { showMessage("Aviso", "Classe removida com sucesso!", 'success', function () { handleReturnRemove(rowData.requerimentoGerador_Id) }) })
                    .catch(err => showMessage("Aviso", err.message, 'error', null))
                    .finally(() => setLoading(false));
            }
        })
    }
    const handleReturnRemove = (reloadId) => {
        setLoading(true);

        api_GET('requerimentoGerador/GetClasseResiduosRequerimentoGerador/' + reloadId)
            .then(result => set_residuos(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const onSubmit = (data) => {
        if (rowEdit == null && residuos.filter(f => f.classeResiduo_Id == classeResiduo.classeResiduo_Id).length > 0) {
            showMessage("Aviso", "Esta classe de resíduos já foi adicionada!", 'error', null);
            return;
        }

        setLoading(true);
        if (permiteManutencao && tipoCadastro == "Protocolo") {
            let json = carregaJsonProtocolo(data);
            EnviaProtocoloGeradorClasseResiduo(json, confirmaAddResiduos)
        }
        else if (tipoCadastro == "Requerimento") {
            let json = carregaJsonRequerimento(data);
            EnviaRequerimentoGeradorClasseResiduo(json, confirmaAddResiduos)
        }
    }
    const carregaJsonProtocolo = (data) => {
        let json_submit = {
            protocoloGeradorClasseResiduo_Id: rowEdit == null ? 0 : rowEdit.protocoloGeradorClasseResiduo_Id,
            protocoloGerador_Id: item.protocoloGerador[0].protocoloGerador_Id,
            classeResiduo_Id: classeResiduo.classeResiduo_Id,
            quantidadeEstimada: data.quantidadeEstimada,
            usuarioUltimaAlteracao_Id: session != null && session.tipoAcesso == "AreaRestrita" ? session.usuario_Id : null
        }
        return json_submit;
    }
    const carregaJsonRequerimento = (data) => {
        let json_submit = {
            requerimentoGeradorClasseResiduo_Id: rowEdit == null ? 0 : rowEdit.requerimentoGeradorClasseResiduo_Id,
            requerimentoGerador_Id: item.requerimentoGerador[0].requerimentoGerador_Id,
            classeResiduo_Id: classeResiduo.classeResiduo_Id,
            quantidadeEstimada: data.quantidadeEstimada,
        }
        return json_submit;
    }
    const confirmaAddResiduos = (result) => {
        setLoading(false);
        let residuo = result.data;
        residuo.classeResiduo = optionsClassesResiduo.filter(x => x.classeResiduo_Id == result.data.classeResiduo_Id)[0];

        let new_list = [];

        let _registro = registro;
        if (tipoCadastro == "Protocolo") {
            residuos.map(m => {
                if (m.protocoloGeradorClasseResiduo_Id != residuo.protocoloGeradorClasseResiduo_Id)
                    new_list.push(m);
            });

            _registro.protocoloGerador[0].protocoloGeradorClasseResiduos = new_list;
        }
        else if (tipoCadastro == "Requerimento") {
            residuos.map(m => {
                if (m.requerimentoGeradorClasseResiduo_Id != residuo.requerimentoGeradorClasseResiduo_Id)
                    new_list.push(m);
            });

            _registro.requerimentoGerador[0].requerimentoGeradorClasseResiduo = new_list;
        }

        new_list.push(residuo);
        set_residuos(new_list);
        set_registro(_registro);

        set_classeResiduo(null);
        setValue("classeResiduo", "", false);
        setValue("quantidadeEstimada", "");
        set_rowEdit(null);

        showMessage("Aviso", "Operação executada com sucesso", 'success', null);
    }

    const handleAvancar = () => {
        if ((session == null || (session && session.tipoAcesso == "Protocolo")) && residuos.length == 0) {
            showMessage("Aviso", "Você não pode avançar sem informar as classes de resíduos", 'error', null);
            return;
        }
        handleProximoStep(registro);
    }

    return (
        <>
            <div>
                <Card className={`card-stats`}>
                    <CardBody>
                        <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                            <h2 className="titulo-solicitacao">Geração de Resíduos</h2>
                            <div className="formPrincipal">
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Row>
                                        <Col md="6" lg="6">
                                            <FormGroup>
                                                <b><label>Classe de Resíduos</label> </b>
                                                <Select
                                                    options={optionsClassesResiduo}
                                                    getOptionLabel={option => option.descricao}
                                                    getOptionValue={option => option.classeResiduo_Id}
                                                    name="classeResiduo"
                                                    onChange={(e) => { handleClassesResiduo(e) }}
                                                    value={classeResiduo && optionsClassesResiduo.find(f => f.classeResiduo_Id === classeResiduo.classeResiduo_Id)}
                                                    placeholder="Selecione"
                                                    ref={e => register(
                                                        { name: "classeResiduo" },
                                                        { required: true })
                                                    }
                                                />
                                                {errors.classeResiduo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="4">
                                            <FormGroup>
                                                <b><label>Quantidade Estimada(Kg)</label></b>
                                                <Input type="number" name="quantidadeEstimada" maxLength="10" innerRef={register({ required: true })} />
                                                {errors.quantidadeEstimada && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="12" lg="12" className="text-center">
                                            <FormGroup>
                                                <Button color="success" className="btn-mobile" type="submit">  <i className="fas fa-save"></i> Salvar</Button>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                            <Row>
                                <Col md="12">
                                    <MaterialTable style={{ minHeight: "auto" }}
                                        title=""
                                        columns={[
                                            { title: 'Classe', field: 'classeResiduo.descricao' },
                                            { title: 'Quantidade Gerada', field: 'quantidadeEstimada' },
                                        ]}
                                        data={residuos}
                                        isLoading={false}
                                        actions={actions}
                                        localization={table_translate}
                                        options={table_style}
                                    />
                                </Col>
                                <Col lg="6" className="text-left">
                                    <Button color="secundary" onClick={() => handleStepAnterior(registro)} className="btn-mobile" type="submit"><i className="fas fa-chevron-left"></i> Voltar</Button>
                                </Col>
                                <Col lg="6" className="text-right">
                                    <Button color="success" onClick={handleAvancar} className="btn-mobile" type="button">Próxima Etapa  <i className="fas fa-chevron-right"></i></Button>
                                </Col>
                            </Row>
                        </Container>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}           